// Google Analytics utility functions
declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event' | 'js' | 'set',
      targetId: string | Date,
      config?: Record<string, any>
    ) => void;
  }
}

export const GA_TRACKING_ID = 'G-06PEYRQNX8';

// Track page views
export const pageview = (url: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Track custom events
export const event = ({
  action,
  category,
  label,
  value,
}: {
  action: string;
  category: string;
  label?: string;
  value?: number;
}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track form submissions
export const trackFormSubmission = (formName: string) => {
  event({
    action: 'form_submit',
    category: 'engagement',
    label: formName,
  });
};

// Track phone clicks
export const trackPhoneClick = (phoneNumber: string) => {
  event({
    action: 'phone_click',
    category: 'contact',
    label: phoneNumber,
  });
};

// Track email clicks
export const trackEmailClick = (emailAddress: string) => {
  event({
    action: 'email_click',
    category: 'contact',
    label: emailAddress,
  });
};

// Track button clicks
export const trackButtonClick = (buttonName: string, location?: string) => {
  event({
    action: 'button_click',
    category: 'engagement',
    label: `${buttonName}${location ? ` - ${location}` : ''}`,
  });
};

// Track quote requests
export const trackQuoteRequest = (serviceType: string) => {
  event({
    action: 'quote_request',
    category: 'conversion',
    label: serviceType,
  });
};

// Track blog article views
export const trackBlogView = (articleTitle: string) => {
  event({
    action: 'blog_view',
    category: 'content',
    label: articleTitle,
  });
};

// Track service page views
export const trackServiceView = (serviceName: string) => {
  event({
    action: 'service_view',
    category: 'engagement',
    label: serviceName,
  });
};

// Track gallery interactions
export const trackGalleryInteraction = (action: string, imageName?: string) => {
  event({
    action: `gallery_${action}`,
    category: 'engagement',
    label: imageName || 'gallery',
  });
};
